import IService from '../IService';

export default IService.extend({
  kalturaProperties: (() => {
    if (sessionStorage.getItem('kalturaProperties')) {
      return JSON.parse(sessionStorage.getItem('kalturaProperties'));
    }
  })(),

  abort() {
    if (this.req) {
      this.req.abort();
      this.req = null;
    }
  },

  isPending() {
    return app.xhrExpected(this.req);
  },

  searchCreativeAssets({
    url,
    props,
    imageProps,
    imageProviderId,
    videoProps,
    videoProviderId,
    cancelCurrent = true,
    nextItemProp,
    rand,
  } = {}) {
    if (cancelCurrent && this.req && app.xhrExpected(this.req)) {
      this.abort();
    }

    const payload = Object.create(null);
    payload.searchRequests = [];
    const isImages = !props.format || props.format === 'IMAGE';
    const isVideos = !props.format || props.format === 'VIDEO';
    const imageKeys = Object.keys(imageProps || {});
    const videoKeys = Object.keys(videoProps || {});
    const hasImageOnlyFilters = !!_.without(imageKeys, ...videoKeys).length;

    if (isImages && imageProviderId) {
      payload.searchRequests.push({
        providerId: imageProviderId,
        searchRequest: imageProps || {},
      });
    }
    if (isVideos && !hasImageOnlyFilters && videoProviderId) {
      payload.searchRequests.push({
        providerId: videoProviderId,
        searchRequest: videoProps || {},
      });
    }

    const promise = new _.ColdPromise();
    this.promise = promise;

    if (_.isEmpty(props.phrase)) {
      props.sortBy = 'DATE';
      if (videoProviderId === 'ClipStock_videos_dynamic') {
        promise.reject(new Error('No search phrase'));
        return promise;
      }
    }

    payload.base = Object.assign({ page: 1 }, props);
    delete payload.base.format;
    this.rand = rand;

    this.req = $.ajax({
      url: app.apiUrl(url),
      contentType: 'application/json',
      dataType: 'json',
      type: 'GET',
      data: { q: JSON.stringify(payload) },

      success: (response) => {
        response = response || {};
        let assets = [];

        if (
          _.isPlainObject(response) &&
          (!_.isEmpty(response.assets) || !_.isEmpty(response.metaAssets))
        ) {
          assets = response.assets || response.metaAssets || [];
        }
        _.each(assets, (asset) => {
          app.namespace.Controller.AssetController.parse(asset);
        });
        response = response || {};
        const result = { assets, rand };
        const nextItem = response[nextItemProp];
        result.noMoreAssets = false;
        if (Object.getOwnPropertyDescriptor(response, nextItemProp)) {
          if (_.isEmpty(nextItem) || nextItem === 0) {
            result.noMoreAssets = true;
          }
        } else {
          result.noMoreAssets = !assets || !assets.length;
        }

        if (response[nextItemProp]) {
          result.nextItem = response[nextItemProp];
        }

        promise.resolve(result);
      },

      error: (err) => {
        promise.reject(err);
      },
    }).always(() => {
      this.req = null;
      this.promise = null;
    });

    return promise;
  },

  searchInternal({
    url,
    props,
    cancelCurrent = true,
    nextItemProp,
    rand,
    contextId,
  } = {}) {
    if (cancelCurrent && this.req && app.xhrExpected(this.req)) {
      this.abort();
    }
    this.rand = rand;
    const promise = new _.ColdPromise();
    this.promise = promise;
    this.req = $.ajax({
      url: app.apiUrl(url),
      contentType: 'application/json',
      dataType: 'json',
      type: 'GET',
      data: props,

      success: (response) => {
        response = response || {};
        let assets = [];

        if (
          _.isPlainObject(response) &&
          (!_.isEmpty(response.assets) || !_.isEmpty(response.metaAssets))
        ) {
          assets = response.assets || response.metaAssets || [];
        }
        _.each(assets, (asset) => {
          app.namespace.Controller.AssetController.parse(asset);
        });
        response = response || {};
        const tags = response.tags;
        const result = { assets, tags, rand };
        const nextItem = response[nextItemProp];
        result.noMoreAssets = false;
        if (Object.getOwnPropertyDescriptor(response, nextItemProp)) {
          if (!assets || _.isEmpty(nextItem) || +nextItem === 0) {
            result.noMoreAssets = true;
          }
        } else {
          result.noMoreAssets = !assets || assets.length < props.numberOfItems;
        }

        if (response[nextItemProp]) {
          result.nextItem = response[nextItemProp];
        }

        promise.resolve(result);
      },

      error: (err) => {
        promise.reject(err);
      },
    }).always(() => {
      this.req = null;
      this.promise = null;
    });

    return promise;
  },

  searchKaltura({
    url,
    props,
    cancelCurrent = true,
    nextItemProp,
    rand,
    contextId,
  } = {}) {
    if (cancelCurrent && this.req && app.xhrExpected(this.req)) {
      this.abort();
    }
    this.rand = rand;
    const promise = new _.ColdPromise();
    this.promise = promise;
    const kalturaParams = {
      responseProfile: {
        objectType: 'KalturaDetachedResponseProfile',
        type: 1,
        fields:
          'id,name,thumbnailUrl,tags,createdAt,description,mediaType,downloadUrl',
        relatedProfiles: [
          {
            objectType: 'KalturaDetachedResponseProfile',
            type: 1,
            fields: 'id,fileExt,width,height,bitrate,tags',
            filter: {
              objectType: 'KalturaFlavorAssetFilter',
              statusEqual: 2,
            },
            mappings: [
              {
                objectType: 'KalturaResponseProfileMapping',
                parentProperty: 'id',
                filterProperty: 'entryIdEqual',
              },
            ],
          },
        ],
      },
      searchParams: {
        orderBy: {
          orderItems: [
            {
              objectType: 'KalturaESearchEntryOrderByItem',
              sortField: 'created_at',
              sortOrder: 'desc',
            },
          ],
        },
        searchOperator: {
          operator: 1,
          searchItems: [
            {
              objectType: 'KalturaESearchEntryOperator',
              operator: 2,
              searchItems: [
                {
                  objectType: 'KalturaESearchEntryItem',
                  fieldName: 'creator_kuser_id',
                  itemType: 1,
                  searchTerm: this.kalturaProperties.userId,
                },
                {
                  objectType: 'KalturaESearchEntryItem',
                  fieldName: 'entitled_kusers_view',
                  itemType: 1,
                  searchTerm: this.kalturaProperties.userId,
                },
                {
                  objectType: 'KalturaESearchEntryItem',
                  fieldName: 'entitled_kusers_edit',
                  itemType: 1,
                  searchTerm: this.kalturaProperties.userId,
                },
                {
                  objectType: 'KalturaESearchEntryItem',
                  fieldName: 'entitled_kusers_publish',
                  searchTerm: this.kalturaProperties.userId,
                  itemType: 1,
                },
              ],
            },
            {
              objectType: 'KalturaESearchEntryOperator',
              operator: 1,
              searchItems: [
                {
                  objectType: 'KalturaESearchEntryOperator',
                  operator: 2,
                  searchItems: [
                    {
                      objectType: 'KalturaESearchEntryItem',
                      fieldName: 'media_type',
                      itemType: 1,
                      searchTerm: '1',
                    },
                    {
                      objectType: 'KalturaESearchEntryItem',
                      fieldName: 'media_type',
                      itemType: 1,
                      searchTerm: '2',
                    },
                  ],
                },
              ],
            },
            // in progress / failed metadata filtering
            {
              objectType: 'KalturaESearchEntryOperator',
              operator: 3,
              searchItems: [
                {
                  objectType: 'KalturaESearchEntryMetadataItem',
                  metadataProfileId: this.kalturaProperties.metadataProfileId,
                  itemType: 1,
                  xpath: "/*[local-name()='metadata']/*[local-name()='State']",
                  searchTerm: 'IN_PROGRESS',
                },
              ],
            },
            {
              objectType: 'KalturaESearchEntryOperator',
              operator: 3,
              searchItems: [
                {
                  objectType: 'KalturaESearchEntryMetadataItem',
                  metadataProfileId: this.kalturaProperties.metadataProfileId,
                  itemType: 1,
                  xpath: "/*[local-name()='metadata']/*[local-name()='State']",
                  searchTerm: 'FAILED',
                },
              ],
            },
          ],
        },
      },
      pager: {
        objectType: 'KalturaFilterPager',
        pageSize: props.count,
        pageIndex: (props[nextItemProp] || 0) + 1,
      },
    };
    this.req = $.ajax({
      url:
        'https://www.kaltura.com/api_v3/service/elasticsearch_esearch/action/searchEntry?' +
        $.param({ ks: this.kalturaProperties.ks, format: 1 }),
      contentType: 'application/json',
      dataType: 'json',
      type: 'POST',
      data: JSON.stringify(kalturaParams),

      success: (response) => {
        response = response || {};
        const assets = [];
        const flavors = [];
        const flavorReqData = {};

        _.each(response.objects, (object) => {
          object = object.object;
          const downloadUrl =
            object.downloadUrl + '/ks/' + this.kalturaProperties.ks;
          const isVideo = object.mediaType === 1;
          const asset = {
            type: isVideo ? app.assetType.VIDEO : app.assetType.IMAGE,
            startTime: 0,
            endTime: 0,
            // bucketDirectory: 'MY_LIBRARY',
            metadata: {
              assetUUID: object.id + '_kaltura',
              providerId: 'kaltura',
              providerAssetId: object.id,
              posterUrl: object.thumbnailUrl + '/height/300',
              thumbnail160x90Url: object.thumbnailUrl + '/height/300',
              providerHiResAssetUrl: downloadUrl,
              providerLowResAssetUrl: downloadUrl,
              urlCdn: downloadUrl,
              assetType: isVideo ? 'VIDEO' : 'IMAGE',
              title: object.name,
              caption: object.description,
              licensed: false,
              creationDate: object.createdAt * 1000,
              publicationDate: object.createdAt * 1000,
              keywords: object.tags ? object.tags.split(',') : null,
              video: !!isVideo,
              dynamic: true,
              privacy: 'PUBLIC',
              contentFamily: 'Editorial',
              fileFormat: isVideo ? 'MP4' : 'JPG',
            },
          };

          app.namespace.Controller.AssetController.parse(asset);
          assets.push(asset);

          if (isVideo) {
            try {
              if (object['relatedObjects'][0].totalCount) {
                const hiRes = object['relatedObjects'][0]['objects'].reduce(
                  (prev, current) => {
                    return prev.bitrate >= current.bitrate &&
                      prev.width > current.width
                      ? prev
                      : current;
                  }
                );
                const lowRes = object['relatedObjects'][0]['objects'].reduce(
                  (prev, current) => {
                    return current.bitrate > 0 &&
                      current.bitrate <= prev.bitrate &&
                      current.width <= prev.width
                      ? current
                      : prev;
                  }
                );
                flavors.push(
                  {
                    assetIndex: assets.length - 1,
                    type: 'hiRes',
                    id: hiRes.id,
                  },
                  {
                    assetIndex: assets.length - 1,
                    type: 'lowRes',
                    id: lowRes.id,
                  }
                );
              }
            } catch (e) {
              console.error(e);
            }
          }
        });

        _.each(flavors, function (flavor, flavorId) {
          flavorReqData[`${flavorId}:action`] = 'getUrl';
          flavorReqData[`${flavorId}:service`] = 'flavorasset';
          flavorReqData[`${flavorId}:id`] = flavor.id;
        });

        const falvorReqsettings = {
          url:
            'https://www.kaltura.com/api_v3/service/multirequest/action/null?' +
            $.param({ ks: this.kalturaProperties.ks, format: 1 }),
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          data: JSON.stringify(flavorReqData),
        };

        response = response || {};
        const result = { assets, rand };
        result.noMoreAssets = assets.length < props.count;
        result.nextItem = (props[nextItemProp] || 0) + 1;

        this.req = $.ajax(falvorReqsettings)
          .done((flavorRes) => {
            _.each(flavorRes, (flavorUrl, fid) => {
              const flavor = flavors[fid];
              const assetMetadata = assets[flavor.assetIndex].metadata;
              if (flavor.type === 'hiRes') {
                Object.assign(assetMetadata, {
                  providerHiResAssetUrl: flavorUrl,
                });
              } else {
                Object.assign(assetMetadata, {
                  providerLowResAssetUrl: flavorUrl,
                  urlCdn: flavorUrl,
                });
              }
            });
            promise.resolve(result);
            this.req = null;
            this.promise = null;
          })
          .fail((res) => {
            // Failed. not too bad, let assets live with their original downloadUrl...
            promise.resolve(result);
            this.req = null;
            this.promise = null;
          });
      },

      error: (err) => {
        promise.reject(err);
        this.req = null;
        this.promise = null;
      },
    });

    return promise;
  },

  searchAssets(...args) {
    let searchFunction;
    switch (args[0].contextId) {
      case 'KALTURA':
        searchFunction = 'searchKaltura';
        break;
      default:
        searchFunction = 'searchInternal';
        break;
    }
    // eslint-disable-next-line prefer-spread
    return this[searchFunction].apply(this, args);
  },
});
